const CANCELLATION_WINDOW_HOURS = 24;

export function isWithinPenaltyWindow(startsAtIso: string, now = new Date()): boolean {
  const startsAt = new Date(startsAtIso);
  const diffMs = startsAt.getTime() - now.getTime();
  const diffHours = diffMs / (1000 * 60 * 60);
  return diffHours < CANCELLATION_WINDOW_HOURS;
}

export function getCancellationPolicySummary(startsAtIso: string, now = new Date()): string {
  return isWithinPenaltyWindow(startsAtIso, now)
    ? 'Cancelling/rescheduling within 24 hours keeps your credit consumed.'
    : 'Cancelling now will refund your credit.';
}
